import React from 'react';

/**
 * ComboboxInput renders a styled select element with provided options.
 * Matches dark mode styling used across the app.
 */
export default function ComboboxInput({
  id,
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select…',
  className = '',
  disabled = false,
  required = false,
}) {
  return (
    <select
      id={id}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      disabled={disabled}
      required={required}
      className={`w-full h-8 px-3 py-2 text-xs border border-[var(--ds-control-field-border)] rounded-[var(--ds-radius-md)] bg-[var(--ds-control-field-bg)] text-[var(--ds-text-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--ds-accent-focus-ring)] focus:border-[var(--ds-accent-primary)] ${className}`}
   >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  );
}


